<template>
  <div class="left" ref="left">
    <el-row>
      <el-col :class="menu_selected==1?'nav_list1 nav_list':'nav_list'">
        <ul  style="margin: 0;">
          <li :class="menu_selected==1?'fl fl_select':'fl'" style="cursor: pointer">
            <el-button type="text" @click="paichang_current">当天排场1厅</el-button>
          </li>
        </ul>
      </el-col>
      <el-col :class="menu_selected==2?'nav_list1 nav_list':'nav_list'">
        <ul  style="margin: 0;">
          <li :class="menu_selected==2?'fl fl_select':'fl'" style="cursor: pointer">
            <el-button type="text" @click="paichang_current2">当天排场2厅</el-button>
          </li>
        </ul>
      </el-col>
      <el-col :class="menu_selected==3?'nav_list1 nav_list':'nav_list'">
        <ul  style="margin: 0;">
          <li :class="menu_selected==3?'fl fl_select':'fl'" style="cursor: pointer">
            <el-button type="text" @click="paichang_history">历史排场</el-button>
          </li>
        </ul>
      </el-col>
      <el-col :class="menu_selected==4?'nav_list1 nav_list':'nav_list'">
        <ul  style="margin: 0;">
          <li :class="menu_selected==4?'fl fl_select':'fl'" style="cursor: pointer">
            <el-button type="text" @click="paichang_LobbyGames">前厅售卖</el-button>
          </li>
        </ul>
      </el-col>
      <el-col :class="menu_selected==5?'nav_list1 nav_list':'nav_list'">
        <ul  style="margin: 0;">
          <li :class="menu_selected==5?'fl fl_select':'fl'" style="cursor: pointer">
            <el-button type="text" @click="paichang_Membership">会员卡销售</el-button>
          </li>
        </ul>
      </el-col>
      <el-col :class="menu_selected==6?'nav_list1 nav_list':'nav_list'">
        <ul  style="margin: 0;">
          <li :class="menu_selected==6?'fl fl_select':'fl'" style="cursor: pointer">
            <el-button type="text" @click="paichang_statistics">查看对账数据</el-button>
          </li>
        </ul>
      </el-col>
      <el-col :class="menu_selected==7?'nav_list1 nav_list':'nav_list'">
        <ul  style="margin: 0;">
          <li :class="menu_selected==7?'fl fl_select':'fl'" style="cursor: pointer">
            <el-button type="text" @click="problem_ostentation">问题修改</el-button>
          </li>
        </ul>
      </el-col>
      <el-col :class="menu_selected==8?'nav_list1 nav_list':'nav_list'">
        <ul  style="margin: 0;">
          <li :class="menu_selected==8?'fl fl_select':'fl'" style="cursor: pointer">
            <el-button type="text" @click="get_version">游戏版本</el-button>
          </li>
        </ul>
      </el-col>
     <el-col :class="menu_selected==9?'nav_list1 nav_list':'nav_list'">
        <ul  style="margin: 0;">
          <li :class="menu_selected==9?'fl fl_select':'fl'" style="cursor: pointer">
            <el-button type="text" @click="get_shopWaiter">服务人员</el-button>
          </li>
        </ul>
      </el-col>
      <el-col :class="menu_selected==10?'nav_list1 nav_list':'nav_list'">
         <ul  style="margin: 0;">
           <li :class="menu_selected==10?'fl fl_select':'fl'" style="cursor: pointer">
             <el-button type="text" @click="get_paiChangWaiting">待排场</el-button>
           </li>
         </ul>
       </el-col>

       <el-col :class="menu_selected==11?'nav_list1 nav_list':'nav_list'">
          <ul  style="margin: 0;">
            <li :class="menu_selected==11?'fl fl_select':'fl'" style="cursor: pointer">
              <el-button type="text" @click="qita1">小程序</el-button>
            </li>
          </ul>
        </el-col>
        <el-col :class="menu_selected==12?'nav_list1 nav_list':'nav_list'">
           <ul  style="margin: 0;">
             <li :class="menu_selected==12?'fl fl_select':'fl'" style="cursor: pointer">
               <el-button type="text" @click="qita2">美团</el-button>
             </li>
           </ul>
         </el-col>
         <el-col :class="menu_selected==13?'nav_list1 nav_list':'nav_list'">
            <ul  style="margin: 0;">
              <li :class="menu_selected==13?'fl fl_select':'fl'" style="cursor: pointer">
                <el-button type="text" @click="qita3">抖音</el-button>
              </li>
            </ul>
          </el-col>

    </el-row>
  </div>
</template>
<script>
  import {
   protocol_miniJump
  } from '@/assets/js/network/request';
export default {
  components: {},
  data () {
    return {
      menu_selected: 1
    }
  },
  methods: {
    get_menu_selected: function () {
      return this.menu_selected
    },
    //
    paichang_current: function () {
      this.menu_selected = 1
      this.$parent.set_menu_clicked(this.menu_selected)
    },
    paichang_current2: function () {
      this.menu_selected = 2
      this.$parent.set_menu_clicked(this.menu_selected)
    },
    paichang_history: function () {
      this.menu_selected = 3
      this.$parent.set_menu_clicked(this.menu_selected)
    },
    paichang_LobbyGames: function () {
      this.menu_selected = 4
      this.$parent.set_menu_clicked(this.menu_selected)
    },
    paichang_Membership: function () {
      this.menu_selected = 5
      this.$parent.set_menu_clicked(this.menu_selected)
    },
    paichang_statistics: function () {
      this.menu_selected = 6
      this.$parent.set_menu_clicked(this.menu_selected)
    },
    problem_ostentation: function () {
      this.menu_selected = 7
      this.$parent.set_menu_clicked(this.menu_selected)
    },
    get_version: function () {
      this.menu_selected = 8
      this.$parent.set_menu_clicked(this.menu_selected)
    },
    get_shopWaiter: function () {
      this.menu_selected = 9
      this.$parent.set_menu_clicked(this.menu_selected)
    },
    get_paiChangWaiting: function () {
      this.menu_selected = 10
      this.$parent.set_menu_clicked(this.menu_selected)
    },
    qita1: function () {
    let _this =this;
    protocol_miniJump().then(res=>{
    _this.tableDataCanAddPaiChang=res.ret;
    console.log(res.ret);
    window.open("https://chenjinxingqiu.ivr.aegis-vr.com/cjstore/#/login?token="+res.ret);
    })
    },
    qita2: function () {
     window.open( "https://ecom.meituan.com/bizaccount/login.html?loginByPhoneNumber=true&isProduction=true&epassportParams=%3Fbg_source%3D1%26service%3Dcom.sankuai.meishi.fe.ecom%26part_type%3D0%26feconfig%3Dbssoify%26biz_line%3D1%26continue%3Dhttps%253A%252F%252Fecom.meituan.com%252Fbizaccount%252Fbiz-choice.html%253Fredirect_uri%253Dhttps%25253A%25252F%25252Fecom.meituan.com%25252Fmeishi%25252F%2526_t%253D1702623171650%2526target%253Dhttps%25253A%25252F%25252Fecom.meituan.com%25252Fmeishi%25252F%26leftBottomLink%3D%26signUpTarget%3Dself"); // 设置新标签页的 URL
    },
    qita3: function () {
    },
  },
  watch: {},
  mounted () {
  }
}
</script>
<style>

.nav_list1{
  background: #007AFF;
}
.nav_list {
  font-size: 16px;
  line-height: 40px;
  color: #333333;
  margin-bottom: 10px;
}
.nav_list>ul{
  padding-left: 20px !important;
}
.left {
  height: calc(100vh - 80px);
  width: 120px;
  background-color: #092f5c;
}
li{
  list-style: none;
}
.fl{
  float: left;
  font-size: 24px !important;
}
.fl_select button{
  color: #FFFFFF !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/LeftMenu.vue